<template>
  <vs-popup
    fullscreen
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      errorColor="rgba(var(--vs-danger), 1)"
      :title="null"
      :subtitle="null"
      finishButtonText="Submit"
    >
      <tab-content
        title="Informasi Dasar"
        class="mb-5"
        icon="feather icon-user"
        :before-change="validateStep1"
      >
        <!-- tab 1 content -->
        <form data-vv-scope="step-1">
          <div class="vx-row">
            <div class="mb-6 vx-col w-full">
              <img
                :src="
                  formData.file !== null
                    ? formData.file.includes('upload//')
                      ? `${url.baseFl}/${formData.file}`
                      : formData.file
                    : formData.file
                "
                alt="sos-img"
                class="rounded-lg shadow-md cursor-pointer block w-full mb-4"
              />
              <div class="flex justify-start items-center">
                <div>
                  <input
                    type="file"
                    class="hidden"
                    ref="updateImgInput"
                    @change="updateCurrImg"
                    accept=".doc, .docx, .xls, .ppt, .pptx, .pdf, .png, .jpg, jpeg, .zip, .rar"
                  />
                  <vs-button
                    class="mr-4 sm:mb-0 mb-2"
                    @click="$refs.updateImgInput.click()"
                    >Upload Gambar SOS</vs-button
                  >
                </div>
                <div v-if="formData.file !== emptyImage">
                  <vs-button
                    class="mr-4 sm:mb-0 mb-2"
                    color="danger"
                    icon="clear"
                    @click="clearBanner"
                  ></vs-button>
                </div>
                <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
              </div>
            </div>
            <div class="mb-6 vx-col w-full">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Nama SOS</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <vs-input
                v-validate="'required'"
                name="name"
                class="w-full sidebar-input"
                v-model="formData.name"
                placeholder="Isi Dengan Nama SOS"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-1.name')"
                >{{ errors.first("step-1.name") }}</span
              >
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/2 lg:w-1/2">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Nama Perorang/Lembaga Penanggung Jawab</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <vs-input
                v-validate="'required'"
                name="pic"
                class="w-full sidebar-input"
                v-model="formData.pic"
                placeholder="Isi Nama Orang/Lembaga yang Bertanggung Jawab (PIC)"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-1.pic')"
                >{{ errors.first("step-1.pic") }}</span
              >
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/2 lg:w-1/2">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Kontak</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <VuePhoneNumberInput
                default-country-code="ID"
                no-country-selector
                @update="formData.kontak = $event.e164"
                v-validate="'required'"
                name="contact"
                :error="formData.kontak === '' || formData.kontak === null"
                v-model="formData.kontak"
                class="w-full mb-3"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-1.contact')"
                >{{ errors.first("step-1.contact") }}</span
              >
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/2 lg:w-1/2">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Kategori SOS</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <v-select
                :options="kategoriList"
                :reduce="(v) => v.id"
                class="w-full"
                v-validate="'required'"
                name="category"
                label="name"
                v-model="formData.kat_id"
                placeholder="Pilih Kategori SOS"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-1.category')"
                >{{ errors.first("step-1.category") }}</span
              >
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/2 lg:w-1/2">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Sub-Kategori SOS</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <v-select
                :options="subKategoriList"
                :reduce="(v) => v.id"
                class="w-full"
                v-validate="'required'"
                :disabled="formData.kat_id === null"
                name="subCategory"
                label="name"
                v-model="formData.sub_id"
                placeholder="Pilih Sub-Kategori SOS"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-1.subCategory')"
                >{{ errors.first("step-1.subCategory") }}</span
              >
            </div>
            <div class="mb-6 vx-col w-full">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Deskripsi</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <vs-textarea
                v-validate="'required'"
                name="description"
                class="w-full sidebar-input"
                v-model="formData.deskripsi"
                placeholder="Isi dengan Deskripsi SOS"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-1.description')"
                >{{ errors.first("step-1.description") }}</span
              >
            </div>
            <div class="mb-6 vx-col w-full">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Status Bayar</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <v-select
                :options="statusBayar"
                :reduce="(v) => v.id"
                class="w-full"
                v-validate="'required'"
                name="paymentStatus"
                label="text"
                v-model="formData.status_bayar"
                placeholder="Pilih Status Bayar"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-1.paymentStatus')"
                >{{ errors.first("step-1.paymentStatus") }}</span
              >
            </div>
          </div>
        </form>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content
        title="Alamat dan Zonasi"
        class="mb-5"
        icon="feather icon-map"
        :before-change="validateStep2"
      >
        <form data-vv-scope="step-2">
          <div class="vx-row">
            <vs-divider position="left" class="vx-col w-full"
              ><span class="text-lg text-black mb-16"
                ><strong>Alamat Layanan SOS</strong></span
              ></vs-divider
            >
            <div class="mb-6 vx-col sm:w-full md:w-1/3 lg:w-1/3">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Provinsi</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <v-select
                :options="provinsiList"
                :reduce="(v) => v.id"
                class="w-full"
                v-validate="'required'"
                name="provinsi"
                label="name"
                v-model="formData.provinsi_id"
                placeholder="Pilih Provinsi"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-2.provinsi')"
                >{{ errors.first("step-2.provinsi") }}</span
              >
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/3 lg:w-1/3">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Kabupaten/Kota</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <v-select
                :options="kabKotList"
                :reduce="(v) => v.id"
                class="w-full"
                v-validate="'required'"
                :disabled="
                  formData.provinsi_id === null || kabKotList.length === 0
                "
                name="kabkot"
                label="name"
                v-model="formData.kabkot_id"
                placeholder="Pilih Kabupaten/Kota"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-2.kabkot')"
                >{{ errors.first("step-2.kabkot") }}</span
              >
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/3 lg:w-1/3">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Kecamatan</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <v-select
                :options="kecamatanList"
                :reduce="(v) => v.id"
                class="w-full"
                v-validate="'required'"
                :disabled="
                  formData.kabkot_id === null || kecamatanList.length === 0
                "
                name="kecamatan"
                label="name"
                v-model="formData.kecamatan_id"
                placeholder="Pilih Kecamatan"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-2.kecamatan')"
                >{{ errors.first("step-2.kecamatan") }}</span
              >
            </div>
            <div class="mb-6 vx-col w-full">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Alamat</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <vs-textarea
                v-validate="'required'"
                name="alamat"
                class="w-full sidebar-input"
                v-model="formData.alamat"
                placeholder="Isi Dengan Alamat"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-2.alamat')"
                >{{ errors.first("step-2.alamat") }}</span
              >
            </div>
            <div class="mb-6 vx-col w-full">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Tentukan Lokasi Map</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <GmapMap
                class="mb-4"
                :center="center"
                :zoom="zoom"
                map-type-id="terrain"
                style="width: 100%; height: 300px"
              >
                <GmapMarker
                  :position="marker"
                  :clickable="true"
                  :draggable="true"
                  @drag="getLocation"
                  @click="center = marker"
                />
              </GmapMap>
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/2 lg:w-1/2">
              <section class="mb-2 flex justify-start gap-1">
                <h6>Latitude</h6>
                <span class="text-danger">*</span>
              </section>
              <vs-input
                v-validate="'required'"
                name="latitude"
                :disabled="true"
                class="w-full sidebar-input"
                v-model="formData.latitude"
                placeholder="Isi Dengan Latitude"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-2.latitude')"
                >{{ errors.first("step-2.latitude") }}</span
              >
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/2 lg:w-1/2">
              <section class="mb-2 flex justify-start gap-1">
                <h6>Longitude</h6>
                <span class="text-danger">*</span>
              </section>
              <vs-input
                v-validate="'required'"
                name="longitude"
                class="w-full sidebar-input"
                :disabled="true"
                v-model="formData.longitude"
                placeholder="Isi Dengan Longitude"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-2.longitude')"
                >{{ errors.first("step-2.longitude") }}</span
              >
            </div>
            <vs-divider position="left" class="vx-col w-full"
              ><span class="text-lg text-black mb-16"
                ><strong>Zonasi</strong></span
              ></vs-divider
            >
            <div class="mb-6 vx-col sm:w-full md:w-1/2 lg:w-1/2">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Status Zona</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <v-select
                :options="statusZonasi"
                :reduce="(v) => v.id"
                class="w-full"
                v-validate="'required'"
                :disabled="formData.kecamatan_id === null && formData.alamat"
                name="zoneStatus"
                label="text"
                v-model="formData.status_zona"
                placeholder="Pilih Status Zonasi"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-2.zoneStatus')"
                >{{ errors.first("step-2.zoneStatus") }}</span
              >
            </div>
            <div class="mb-6 vx-col sm:w-full md:w-1/2 lg:w-1/2">
              <section class="mb-4 flex justify-start gap-1">
                <h6><strong>Zona Operasi</strong></h6>
                <span class="text-danger">*</span>
              </section>
              <v-select
                multiple
                :options="zonasiList"
                :reduce="(v) => v.id"
                class="w-full"
                v-validate="'required'"
                :disabled="
                  formData.status_zona === null &&
                  formData.kecamatan_id === null
                "
                name="zonasi"
                label="name"
                v-model="zonasiSelect"
                placeholder="Pilih Zonasi"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('step-2.zonasi')"
                >{{ errors.first("step-2.zonasi") }}</span
              >
            </div>
          </div>
        </form>
      </tab-content>

      <!-- tab 3 content -->
      <tab-content
        title="Persyaratan"
        class="mb-5"
        icon="feather icon-paperclip"
        :before-change="validateStep3"
      >
        <form data-vv-scope="step-3">
          <div class="vx-row">
            <input
              type="file"
              class="hidden"
              ref="updateFile"
              @change="addFileSyarat($event, syaratObj)"
              accept="image/*"
            />
            <div class="w-full">
              <vs-table
                stripe
                :data="syarats"
                v-model="selected"
                :max-items="10"
                pagination
              >
                <template slot="thead">
                  <vs-th>Nama Persyaratan</vs-th>
                  <vs-th>URL/File</vs-th>
                  <vs-th>Aksi</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                    <vs-td>{{
                      syaratKumpulFile.find(
                        (v) => v.syarat.id === data[indextr].id
                      ) === undefined
                        ? "(File tidak ada)"
                        : fileRecorder(
                            syaratKumpulFile.find(
                              (v) => v.syarat.id === data[indextr].id
                            )
                          )
                    }}</vs-td>
                    <vs-td>
                      <div class="flex justify-start gap-2">
                        <vs-button
                          :disabled="disablelityTambah(data[indextr].id)"
                          color="primary"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-upload"
                          @click="updateFilePersyaratan(data[indextr])"
                        >
                          Tambah
                        </vs-button>
                        <vs-button
                          v-if="disablelityFile(data[indextr].id)"
                          color="danger"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-trash"
                          @click="clearFile(data[indextr].id)"
                        >
                          Clear
                        </vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </form>
      </tab-content>
    </form-wizard>
  </vs-popup>
</template>

<script>
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import url from "@/url.js";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

// For custom error message
import { Validator } from "vee-validate";
const dict = {
  custom: {
    name: {
      required: "Harap isi nama SOS!",
    },
    pic: {
      required: "Harap isi nama orang atau lembaga yang bertanggung jawab!",
    },
    contact: {
      required: "Harap isi nomor kontak SOS!",
    },
    category: {
      required: "Harap isi kategori!",
    },
    subCategory: {
      required: "Harap isi sub-kategori!",
    },
    description: {
      required: "Harap isi deskripsi!",
    },
    provinsi: {
      required: "Harap isi provinsi!",
    },
    kabkot: {
      required: "Harap isi kabupaten/kota!",
    },
    kecamatan: {
      required: "Harap isi kecamatan!",
    },
    alamat: {
      required: "Harap isi alamat!",
    },
    zoneStatus: {
      required: "Harap isi status zona!",
    },
    zonasi: {
      required: "Harap isi daftar zonasi!",
    },
    paymentStatus: {
      required: "Harap isi status pembayaran!",
    },
  },
};

// register custom messages
Validator.localize("en", dict);

export default {
  props: {
    kategoriList: { type: Array, default: [] },
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      limitDataTables,
      binaryFile: "",
      selected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      statusZonasi: [
        {
          id: 1,
          text: "Kabupaten/Kota",
        },
        {
          id: 2,
          text: "Kecamatan",
        },
      ],
      statusBayar: [
        {
          id: 1,
          text: "Berbayar",
        },
        {
          id: 2,
          text: "Gratis",
        },
      ],
      sosData: null,
      syarats: [],
      syaratKumpulFile: [],
      syaratObj: null,
      subKategoriList: [],
      center: { lat: -7.073736003627849, lng: 107.65912173890158 },
      marker: { lat: -7.073736003627849, lng: 107.65912173890158 },
      kabKotList: [],
      kecamatanList: [],
      zonasiSelect: [],
      zoom: 5,
      provinsi_id: null,
      formData: {
        file: emptyImage,
        name: "",
        kat_id: null,
        alamat: "",
        kontak: "",
        latitude: null,
        longitude: null,
        pic: "",
        kabkot_id: null,
        sub_id: null,
        kecamatan_id: null,
        provinsi_id: null,
        status_zona: null,
        zonasi: "",
        status_bayar: null,
        deskripsi: "",
      },
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    titlePopUp() {
      return this.passData != null ? "Edit SOS" : "Tambah SOS";
    },
    provinsiList() {
      return this.$store.state.wilayah.provinsiList;
    },
    findAlamat() {
      return {
        kecamatan: this.formData.kecamatan_id,
        kabKot: this.formData.kabkot_id,
        provinsi: this.formData.provinsi_id,
      };
    },
    zonasiList() {
      return this.formData.status_zona === 1
        ? this.kabKotList
        : this.kecamatanList;
    },
    titlePopUp() {
      return this.passData != null ? "Edit SOS" : "Tambah SOS";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    checkZonaSelected() {
      return {
        status_zona: this.formData.status_zona,
        kabkot_id: this.formData.kabkot_id,
        kecamatan_id: this.formData.kecamatan_id,
      };
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
    subId() {
      return this.formData.sub_id;
    },
    kategoriId() {
      return this.formData.kat_id;
    },
    kabKotId() {
      return this.formData.kabkot_id;
    },
    provinsiId() {
      return this.formData.provinsi_id;
    },
    kecamatanId() {
      return this.formData.kecamatan_id;
    },
  },
  methods: {
    // changeKabkot(event) {
    //   if (event !== null) {
    //     console.log('kabkot')
    //     if (this.formData.kecamatan_id !== null) {
    //       this.formData.kecamatan_id = null;
    //     }
    //   }
    // },
    // changeProvinsi(event) {
    //   if (event !== null) {
    //     console.log('provinsi')
    //     if (this.formData.kabkot_id !== null) {
    //       this.formData.kabkot_id = null;
    //     }
    //   }
    // },
    clearBanner() {
      this.formData.file = this.emptyImage;
      this.binaryFile = "";
    },
    clearFile(syaratId) {
      if (
        this.syaratKumpulFile.find((v) => v.syarat.id == syaratId).id ===
        undefined
      ) {
        if (
          this.syaratKumpulFile.find((v) => v.syarat.id == syaratId)
            .binaryFile !== undefined
        ) {
          delete this.syaratKumpulFile.find((v) => v.syarat.id == syaratId)
            .binaryFile;
        }
        this.syaratKumpulFile.find((v) => v.syarat.id == syaratId).file = null;
      } else {
        this.deleteSyaratKumpul(
          this.syaratKumpulFile.find((v) => v.syarat.id == syaratId).id
        );
      }
    },
    disablelityFile(syaratId) {
      if (
        this.syaratKumpulFile.find((v) => v.syarat.id == syaratId) !== undefined
      ) {
        let file = this.syaratKumpulFile.find((v) => v.syarat.id == syaratId);
        if (file.file !== null) {
          return true;
        }

        return false;
      }

      return false;
    },
    deleteSyaratKumpul(id) {
      this.$vs.loading({
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("sos/cudSyaratKumpulSOS", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Persyaratan ${v.syarat.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getSyaratKumpul();
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    disablelityTambah(syaratId) {
      if (
        this.syaratKumpulFile.find((v) => v.syarat.id == syaratId) !== undefined
      ) {
        let files = this.syaratKumpulFile.find((v) => v.syarat.id == syaratId);
        if (
          this.syaratKumpulFile.find((v) => v.syarat.id == syaratId).id !==
          undefined
        ) {
          if (files.file !== null) {
            if (files.file !== null && files.binaryFile !== undefined) {
              return true;
            }

            return true;
          }

          return false;
        } else {
          if (files.binaryFile !== undefined) {
            if (files.binaryFile !== null) {
              return true;
            }

            return false;
          }
          return false;
        }
      }

      return false;
    },
    updateFilePersyaratan(syarat) {
      this.syaratObj = syarat;
      this.$refs.updateFile.click();
    },
    fileRecorder(v) {
      return v.file !== undefined
        ? v.file
          ? v.binaryFile !== undefined
            ? v.binaryFile.name.split("/").slice(-1)[0]
            : v.file.includes("upload//")
            ? `${this.url.baseFl}/${v.file}`
            : v.file.split("/").slice(-1)[0]
          : "(File tidak ada)"
        : "(File tidak ada)";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    addFileSyarat(input, syarat) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (
            this.syaratKumpulFile.find((v) => v.syarat.id === syarat.id) ===
            undefined
          ) {
            this.syaratKumpulFile.push({
              syarat: syarat,
              file: e.target.result,
              binaryFile: input.target.files[0],
            });
            console.log(this.syaratKumpulFile);
          } else {
            let files = this.syaratKumpulFile.find(
              (v) => v.syarat.id === syarat.id
            );
            files.file = e.target.result;
            if (files.binaryFile === undefined) {
              files = Object.assign(files, {
                binaryFile: input.target.files[0],
              });
            } else {
              files.binaryFile = input.target.files[0];
            }
          }
          // this.formData.file = e.target.result;
          // this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then((result) => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then((result) => {
          if (result) {
            this.addWithOption();

            // if (this.kecamatanList.length === 0) {
            //   if (this.formData.kabkot_id !== null) {
            //     this.getKecamatan();
            //   }
            // }
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then((result) => {
          if (result) {
            this.addAllSyarat();
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    findLocation(kec, kot, prov) {
      let addressObj = {
        address_line_1: kec,
        city: kot,
        state: prov,
        country: "Indonesia",
      };

      this.$geocoder.send(addressObj, (response) => {
        if (response.status === "OK") {
          if (response.results.length !== 0) {
            let _lat =
              response.results[response.results.length - 1].geometry.location
                .lat;
            let _lng =
              response.results[response.results.length - 1].geometry.location
                .lng;
            this.marker = {
              lat: _lat,
              lng: _lng,
            };
            // this.center = {
            //   lat: response.results.splice(-1)[0].geometry.location.lat,
            //   lng: response.results.splice(-1)[0].geometry.location.lng,
            // };
            this.formData.latitude = _lat;
            this.formData.longitude = _lng;
          } else {
            this.$vs.notify({
              position: "top-right",
              title: "Lokasi Tidak Ditemukan!!",
              text: "Atur lokasi kembali untuk menemukan lokasi yang diinginkan",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        } else {
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: "Terjadi kesalahan, silahkan periksa jaringan anda",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
    resetForm() {
      this.zoom = 5;
      this.formData.file = this.emptyImage;
      this.provinsi_id = null;
      this.formData.name = "";
      this.formData.kat_id = null;
      this.formData.alamat = "";
      this.formData.kontak = "";
      this.formData.latitude = -7.073736003627849;
      this.formData.longitude = 107.65912173890158;
      this.formData.pic = "";
      this.formData.kabkot_id = null;
      this.formData.sub_id = null;
      this.formData.kecamatan_id = null;
      this.formData.status_zona = null;
      this.formData.zonasi = "";
      this.zonasiSelect = [];
      this.formData.provinsi_id = null;
      this.formData.status_bayar = null;
      this.formData.deskripsi = "";
      this.syaratKumpulFile = [];
      this.syarats = [];
      // this.sosData = null;
      this.marker = { lat: -7.073736003627849, lng: 107.65912173890158 };
      //this.center = { lat: -7.073736003627849, lng: 107.65912173890158 };
    },
    getLocation(location) {
      (this.formData.latitude = location.latLng.lat()),
        (this.formData.longitude = location.latLng.lng());
      this.marker = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    getKecamatan() {
      this.$store
        .dispatch("wilayah/getKecamatan", {
          kabkot_id: this.formData.kabkot_id,
        })
        .then((v) => {
          this.kecamatanList = v.data;
          if (
            this.kecamatanList.length !== 0 &&
            this.formData.kecamatan_id !== null
          ) {
            if (
              this.kecamatanList.find(
                (v) => v.id === this.formData.kecamatan_id
              ) === undefined
            ) {
              this.formData.kecamatan_id = null;
            }
          }
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    //SYARAT METHOD
    addAllSyarat() {
      if (this.syaratKumpulFile.length !== 0) {
        this.$vs.loading({
          color: "primary",
        });
        this.syaratKumpulFile.forEach((i) => {
          if (i.binaryFile !== undefined) {
            this.addWithFile(i.binaryFile, i.syarat.id);
          } else {
            this.addDataSyarat(i.syarat.id, i.file);
          }
        });
        this.$vs.loading.close();
        this.closeWithLoad(true);
      } else {
        this.$vs.notify({
          position: "top-right",
          title: "Mengirim Persyaratan Gagal!",
          text: "File persyaratan tidak ada yang di upload",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    addWithFile(binaryFile = null, syaratId) {
      this.$store
        .dispatch(
          "file/addFile",
          binaryFile === null ? this.binaryFile : binaryFile
        )
        .then((v) => {
          if (binaryFile !== null) {
            let files = v.link;
            this.addDataSyarat(syaratId, files);
          } else {
            this.formData.file = v.link;
            this.addData();
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addDataSyarat(syaratId, file) {
      let idData = {};
      if (
        this.syaratKumpulFile.find((v) => v.syarat.id === syaratId) !==
        undefined
      ) {
        if (
          this.syaratKumpulFile.find((v) => v.syarat.id === syaratId).id !==
          undefined
        ) {
          idData = {
            id: this.syaratKumpulFile.find((v) => v.syarat.id === syaratId).id,
          };
        }
      }

      this.$store
        .dispatch("sos/cudSyaratKumpulSOS", [
          {
            sos_id: this.sosData.id,
            syarat_id: syaratId,
            status: this.profile.level.id === 2 ? 1 : 2,
            deskripsi: "-",
            file: file,
            ...idData,
          },
        ])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title:
              this.itemEdit !== null
                ? "Edit File Persyaratan Sukses!"
                : "Tambah File Persyaratan Sukses!",
            text:
              this.itemEdit !== null
                ? `File Persyaratan ${
                    v.file.split("/").splice(-1)[0]
                  } Berhasil diedit`
                : `File Persyaratan ${
                    v.file.split("/").splice(-1)[0]
                  } Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    //TAMBAH DATA DASAR SOS

    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      if (this.binaryFile === "") {
        this.addData();
      } else {
        this.addWithFile();
      }
    },
    addData() {
      let id = {};

      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === this.emptyImage) {
        this.formData.file = null;
      }
      this.formData.zonasi = this.zonasiSelect.join(",");
      this.$store
        .dispatch("sos/cudSOS", [
          Object.assign(this.formData, id, { user_id: this.profile.id }),
        ])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit SOS Sukses!"
                : "Tambah SOS Sukses!",
            text:
              this.passData !== null
                ? `SOS ${v.name} Berhasil diedit`
                : `SOS ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.sosData = v;
          console.log(v);
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getSyaratKumpul() {
      this.$vs.loading({
        color: "primary",
      });
      this.$store
        .dispatch("sos/getSyaratKumpulSOS", { sos_id: this.passData.id })
        .then((v) => {
          this.$vs.loading.close();
          this.syaratKumpulFile = v.data;
          console.log(this.syaratKumpulFile);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  watch: {
    checkZonaSelected: {
      handler(v) {
        if (v.kabkot_id === null || v.kecamatan_id === null) {
          this.zonasiSelect = [];
          this.formData.status_zona = null;
        }

        if (v.status_zona !== null && this.zonasiList.length !== 0) {
          if (this.zonasiSelect.length !== 0) {
            if (
              this.zonasiList.find(
                (v) => this.zonasiSelect.find(a => a.id === v.id)
              ) === undefined
            ) {
              this.formData.sub_id = null;
            }
            this.zonasiSelect = [];
          }
        }
      },
      deep: true,
    },
    subId() {
      if (this.formData.sub_id !== null) {
        this.syarats = this.$store.getters["sos/getFilteredSyarat"](
          this.formData.sub_id
        );
      }
    },
    kategoriId() {
      if (this.formData.kat_id !== null) {
        this.subKategoriList = this.$store.getters[
          "sos/getFilteredSubKategori"
        ](this.formData.kat_id);
        if (this.formData.sub_id !== null) {
          if (
            this.subKategoriList.find((v) => v.id === this.formData.sub_id) ===
            undefined
          ) {
            this.formData.sub_id = null;
          }
        }
      } else {
        this.formData.sub_id = null;
      }
    },
    provinsiId() {
      if (this.formData.provinsi_id !== null) {
        this.kabKotList = this.$store.getters["wilayah/getFilteredKabKot"](
          this.formData.provinsi_id
        );
        if (this.formData.kabkot_id !== null) {
          if (
            this.kabKotList.find((v) => v.id === this.formData.kabkot_id) ===
            undefined
          ) {
            this.formData.kabkot_id = null;
          }
        }
      } else {
        this.formData.kabkot_id = null;
      }
    },
    kabKotId() {
      if (this.formData.kabkot_id !== null) {
        this.getKecamatan();
      } else {
        this.formData.kecamatan_id = null;
      }
    },
    activate() {
      if (this.passData !== null) {
        let _lat = Number.parseFloat(this.passData.latitude);
        let _lng = Number.parseFloat(this.passData.longitude);
        this.marker = {
          lat: _lat,
          lng: _lng,
        };
        this.sosData = this.passData;
        this.formData.file = this.getPathFoto(this.passData);
        this.provinsi_id = this.passData.kecamatan.kabkot.provinsi.id;
        this.formData.latitude = _lat;
        this.formData.longitude = _lng;
        this.formData.provinsi_id = this.passData.kecamatan.kabkot.provinsi.id;
        this.formData.name = this.passData.name;
        this.formData.kat_id = this.passData.sub_kategori.kategori.id;
        this.formData.alamat = this.passData.alamat;
        this.formData.kontak = this.passData.kontak;
        this.formData.pic = this.passData.pic;
        this.formData.kabkot_id = this.passData.kecamatan.kabkot.id;
        this.formData.status_zona = this.passData.status_zona.id;
        this.formData.sub_id = this.passData.sub_kategori.id;
        this.formData.kecamatan_id = this.passData.kecamatan.id;
        this.formData.status_bayar = this.passData.status_bayar;
        this.formData.deskripsi = this.passData.deskripsi;
        this.zonasiSelect = this.passData.zonasi;
        this.getSyaratKumpul();
        //this.findLocation(this.passData.kecamatan.name, this.passData.kecamatan.kabkot.name, this.passData.kecamatan.kabkot.provinsi.name)
      } else {
        this.resetForm();
      }
    },
    findAlamat: {
      handler(val) {
        if (
          this.kecamatanList.length !== 0 &&
          this.kabKotList.length !== 0 &&
          this.provinsiList.length !== 0
        ) {
          if (
            val.provinsi !== null &&
            val.kabKot !== null &&
            val.kecamatan !== null
          ) {
            this.findLocation(
              this.kecamatanList.find(
                (v) => v.id === this.formData.kecamatan_id
              ).name,
              this.kabKotList.find((v) => v.id === this.formData.kabkot_id)
                .name,
              this.provinsiList.find((v) => v.id === this.formData.provinsi_id)
                .name
            );
          }
        }
      },
      deep: true,
    },
  },
  components: {
    FormWizard,
    TabContent,
    VuePhoneNumberInput,
  },
};
</script>

<style lang="scss" scoped>
img {
  max-height: 340px;
  overflow: auto;
  object-fit: cover;
}
</style>
